import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
export default {
  data: function data() {
    return {
      searchForm: {
        count: 20,
        page: 1,
        user_id: this.$route.query.id,
        status: "2"
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    inviteTypeLink: function inviteTypeLink(row) {
      if (row.from == "lifestyle") {
        window.open("https://www.wellcee.com/lifestyle/wellcee?id=" + row.from_obj_info.id);
      } else if (row.from == "house") {
        window.open("https://www.wellcee.com/rent-apartment/" + row.from_obj_info.id);
      }
    },
    // 结算
    settlementCityMaster: function settlementCityMaster(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this2.$confirm("请确认审核完成后结算?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _this2.$api.settlementCityMaster({
                        user_id: _this2.$route.query.id
                      });
                    case 1:
                      // 操作上报
                      _this2.$operationLog.push({
                        code: 'settlement',
                        userId: _this2.$route.query.id,
                        operationType: "city_master",
                        detailBatchNo: _this2.$route.query.phone
                      });
                      _this2.$message.success("操作成功");
                      _this2.getData();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 设为有效 | 无效
    auditItem: function auditItem(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this3.$confirm("是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _context4.n = 1;
                      return _this3.$api.setCityMasterInviteRecord({
                        user_id: _this3.$route.query.id,
                        ids: [row.id],
                        payment_status: row.payment_status == 0 ? 2 : 0
                      });
                    case 1:
                      _this3.$message.success("操作成功");
                      _this3.getData();
                    case 2:
                      return _context4.a(2);
                  }
                }, _callee4);
              })));
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    sortChange: function sortChange(row) {
      console.log(row);
      if (row.prop == "status_time" && row.order == "descending") {
        this.searchForm.order = "-status_time";
      } else if (row.prop == "status_time" && row.order == "ascending") {
        this.searchForm.order = "status_time";
      } else {
        this.searchForm.order = "";
      }
      this.getData();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.page = 1;
              }
              _this4.tableLoading = true;
              _context6.n = 1;
              return _this4.$api.getCityMasterInviteRecord(_this4.searchForm);
            case 1:
              res = _context6.v;
              _this4.tableData = res.data;
              _this4.total = res.page.total;
              _this4.tableLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    }
  }
};